module.exports = __webpack_public_path__ + "img/Taiwan-4-hover.754d6e38.jpg";